exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes blink {\n  0% {\n    opacity: .2; }\n  20% {\n    opacity: 1; }\n  100% {\n    opacity: .2; } }\n\n@keyframes blink {\n  0% {\n    opacity: .2; }\n  20% {\n    opacity: 1; }\n  100% {\n    opacity: .2; } }\n\n.saving {\n  display: inline; }\n  .saving h3 {\n    -webkit-animation-name: blink;\n            animation-name: blink;\n    -webkit-animation-duration: 1.4s;\n            animation-duration: 1.4s;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    display: inline; }\n\n.saving h3:nth-child(2) {\n  -webkit-animation-delay: .2s;\n          animation-delay: .2s; }\n\n.saving h3:nth-child(3) {\n  -webkit-animation-delay: .4s;\n          animation-delay: .4s; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/loading-ellipsis/loading-ellipsis.component.scss
// module id = ../../../../../src/app/loading-ellipsis/loading-ellipsis.component.scss
// module chunks = main